// Component Name:  AddHost component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: AddProduct
// Date:
// Description: This component to create a new host.
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version
import React, { useEffect, useState } from "react";
import { Container, Card, CardBody, Row, Col, Form, FormGroup, Label, Input, Button, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import { validatePinCode } from "../../api/utils/pinCode";
import { ActiveBtn, CancelBtn, InActiveBtn } from "../Utility/Button";
import { inputRequired } from "../Utility/utilsFunctions";
import { hostRegisterValidationTab1 } from "../../api/utils/validateAPI";
import { connect } from "react-redux";
import { failureToast, warningToast } from "../../store/dbFilter/actions";
import { getHostById, hostRegister } from "../../api/authAPI";
import { hostSelected } from "../../store/hostTech/actions";

const AddHost = (props) => {
  // console.log("Google api key: ",googleAPIKey);
  const { selectedHostId, hostSelected } = props;
  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Add Host", link: "#" },
  ];
  // when modal is opened modal will be the root element
  const [activeTab, setActiveTab] = useState(1);
  const [host, setHost] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    type: "",
    role: "Host",
    gst: "",
    address: "",
  });
  const [addressData, setAddressData] = useState({
    country: "India",
    state: "",
    city: "",
    pincode: "",
  });
  const countryid = 101;
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  // fetch state data
  useEffect(() => {
    if (selectedHostId?.length > 0) {
      fetchHostData(props.selectedHostId);
    }

    if (stateList?.length === 0) {
      GetState(countryid).then((result) => {
        setStateList(result);
      });
    }
    return () => {
      hostSelected("");
    };
  }, []);

  const fetchHostData = async (id) => {
    try {
      const data = await getHostById(id);
      const { name, phoneNumber, email, type, gst, address } = data;
      setHost({
        name: name,
        phoneNumber: phoneNumber,
        email: email,
        type: type,
        role: "Host",
        gst: gst,
        address: address,
      });
    } catch (err) {
      console.log("Error getting the Location", err.msg);
    }
  };
  // handle the input data to store in the host state
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    console.log("name: ", name, value);

    setHost({
      ...host,
      [name]: value,
    });
  };

  /**
   * Makes a call to create a new host or update the existing one
   */
  const handleHostRegister = async () => {
    try {
      let pinCodeValidated = true;
      if (host?.pincode?.length > 0) {
        const flag = await validatePin();
        pinCodeValidated = flag;

        console.log("pinCodeValidate", flag);
      }
      if (pinCodeValidated) {
        const address = `${host?.address}, ${addressData?.city},  ${addressData?.state}, ${addressData?.country}, ${addressData?.pincode}`;
        const hostDetails = { ...host, parentId: props?.email, address: address };
        console.log("hostDetails: ", hostDetails);
        await hostRegister(hostDetails);
        resetHostData();
      } else {
        props.warningToast({ title: "Validation", message: "Enter Valid PinCode" });
      }
    } catch (err) {
      console.log("Error creating/updating chargers: ", err.msg);
    }
  };
  // validate the inputs for the tab 1
  const validateTab = async () => {
    try {
      const { name, phoneNumber, email, type, gst } = host;
      await hostRegisterValidationTab1.validate({ name, phoneNumber, email, type, gst });
      return true;
    } catch (err) {
      if (err.name === "ValidationError") {
        const msg = "Validation Error: " + err.errors.join(", ");
        props.warningToast({ title: "Validation", message: msg });
        return false;
      }
      props.failureToast({ title: "Error", message: "Unexpected Validation Error" });
    }
  };
  const handleToggleTab = async (tab) => {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        if (activeTab === 1 && tab === 2) {
          const isValidated = await validateTab();
          if (isValidated) {
            setActiveTab(tab);
          }
        } else {
          setActiveTab(tab);
        }
      }
    }
  };

  const resetHostData = () => {
    setHost({
      name: "",
      phoneNumber: "",
      email: "",
      type: "",
      role: "Host",
      gst: "",
    });
    setAddressData({
      country: "India",
      state: "",
      city: "",
      pincode: "",
    });
    handleToggleTab(1);
  };
  // validate whether pincode is valid or not
  const validatePin = async () => {
    const { value, flag } = await validatePinCode(host.pincode, host.state);
    // alert(value);
    return flag;
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Add host" breadcrumbItems={breadcrumbItems} />
          <Row className="mt-20">
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="addproduct-nav-pills-wizard" className="twitter-bs-wizard">
                    <Nav pills justified className="twitter-bs-wizard-nav">
                      <NavItem>
                        <NavLink
                          onClick={() => handleToggleTab(1)}
                          className={classnames({
                            active: activeTab === 1,
                          })}
                        >
                          <span className="step-number">01</span>
                          <span className="step-title">Basic Info</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => handleToggleTab(2)}
                          className={classnames({
                            active: activeTab === 2,
                          })}
                        >
                          <span className="step-number">02</span>
                          <span className="step-title">Location Info</span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab} className="twitter-bs-wizard-tab-content">
                      <TabPane tabId={1}>
                        <h4 className="card-title">Basic Information</h4>
                        <p className="card-title-desc" style={{ margin: 0 }}>
                          Fill all information below
                        </p>

                        {/* Form for Host Details */}
                        <Form style={{ marginTop: "25px" }}>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="name">Name{inputRequired()}</Label>
                                <Input id="name" name="name" type="text" className="form-control" value={host.name} onChange={handleFormChange} />
                              </FormGroup>{" "}
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="role">Role{inputRequired()}</Label>
                                <Input id="role" name="role" type="text" className="form-control" value={host.role} required disabled style={{ cursor: "not-allowed" }} />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="phoneNumber">Phone Number</Label>
                                <Input id="phoneNumber" name="phoneNumber" type="text" className="form-control" value={host.phoneNumber} onChange={handleFormChange} />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="email">Email Id{inputRequired()}</Label>
                                <Input id="email" name="email" type="email" className="form-control" value={host.email} onChange={handleFormChange} />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="type">Type{inputRequired()}</Label>
                                <select id="type" name="type" type="text" className="form-control" value={host.type} onChange={handleFormChange}>
                                  <option value={""}>Select Type</option>
                                  <option value={"RWA"}>RWA</option>
                                  <option value={"CPO"}>CPO</option>
                                  <option value={"FM"}>Facility Management</option>
                                  <option value={"OTH"}>Others</option>
                                </select>
                              </FormGroup>{" "}
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="gst">GST</Label>
                                <Input id="gst" name="gst" type="text" className="form-control" value={host.gst} onChange={handleFormChange} />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </TabPane>
                      <TabPane tabId={2}>
                        <h4 className="card-title">Location Information</h4>
                        <p className="card-title-desc">Fill all information below</p>
                        <Form>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="country">Country</Label>
                                <Input
                                  id="country"
                                  name="country"
                                  type="text"
                                  className="form-control text-muted"
                                  value="India"
                                  onChange={handleFormChange}
                                  style={{ cursor: "not-allowed" }}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="state">State</Label>
                                <select
                                  id="state"
                                  name="state"
                                  type="text"
                                  className="form-control"
                                  value={host.state}
                                  onChange={(e) => {
                                    const selectedState = stateList.find((item) => item.name === e.target.value);
                                    if (selectedState) {
                                      GetCity(countryid, selectedState.id).then((result) => {
                                        setCityList(result);
                                      });
                                    }

                                    handleFormChange(e);
                                  }}
                                >
                                  <option value="">Select State</option>
                                  {stateList?.map((item, index) => (
                                    <option key={item?.name} value={item?.name}>
                                      {item?.name}
                                    </option>
                                  ))}
                                </select>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="city">City</Label>
                                <select id="city" name="city" type="text" className="form-control" value={host.city} onChange={handleFormChange}>
                                  <option value="">Select City</option>
                                  {cityList?.map((item, index) => (
                                    <option key={item?.name} value={item?.name}>
                                      {item?.name}
                                    </option>
                                  ))}
                                </select>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="pincode">PinCode</Label>
                                <Input id="pincode" name="pincode" type="text" className="form-control" value={host.pincode} onChange={handleFormChange} />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label htmlFor="address">Address</Label>
                                <textarea className="form-control" id="address" name="address" rows="3" value={host.address} onChange={handleFormChange}></textarea>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                        <div className="d-flex justify-content-center mt-4">
                          {/* <Button color="primary" type="submit" className="mr-2 waves-effect waves-light" onClick={validatePin} >
                            { "Add host"}
                          </Button>
                          <Button color="light" type="submit" className="waves-effect ml-1">
                            Cancel
                          </Button> */}
                          <ActiveBtn name={"Add host"} handleClick={handleHostRegister} />
                          <CancelBtn name={"Cancel"} handleClick={() => {}} />
                        </div>
                      </TabPane>
                    </TabContent>
                    <ul className="pager wizard twitter-bs-wizard-pager-link d-flex justify-content-between">
                      <li>
                        {/* <Link
                          to="#"
                          onClick={() => {
                            handleToggleTab(activeTab - 1);
                          }}
                        >
                          Previous
                        </Link> */}
                        {activeTab === 1 ? (
                          <InActiveBtn name={"Previous"} />
                        ) : (
                          <ActiveBtn
                            name={"Previous"}
                            handleClick={() => {
                              handleToggleTab(activeTab - 1);
                            }}
                          />
                        )}
                      </li>
                      <li>
                        {/* <Link
                          to="#"
                          onClick={() => {
                            handleToggleTab(activeTab + 1);
                          }}
                        >
                          Next
                        </Link> */}
                        {activeTab === 2 ? (
                          <InActiveBtn name={"Next"} />
                        ) : (
                          <ActiveBtn
                            name={"Next"}
                            handleClick={() => {
                              handleToggleTab(activeTab + 1);
                            }}
                          />
                        )}
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  email: state?.Login?.user?.email,
  selectedHostId: state?.HostTechManagement?.selectedHostId,
});
export default connect(mapStateToProps, { warningToast, failureToast, hostSelected })(AddHost);
